import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SharedService {
    //Formularios
    //Formulario Transporte aereo
    private aereosForm = new BehaviorSubject<any>(null);
    public aereosForm$ = this.aereosForm.asObservable();
    //Formulario Pedimentos
    private pedimentos = new BehaviorSubject<any>(null);
    public pedimentos$ = this.pedimentos.asObservable();
    //idFactura
    private idFactura = new BehaviorSubject<any>(null);
    public idFactura$ = this.idFactura.asObservable();
    
    private formularioSubject = new BehaviorSubject<any>(null);
    public formulario$ = this.formularioSubject.asObservable();

    private AdicionalesformularioSubject = new BehaviorSubject<any>(null);
    public Adicionalesformulario$ = this.AdicionalesformularioSubject.asObservable();

    private llenarForm = new BehaviorSubject<any>(null);
    public AdicionalesllenarForm$ = this.llenarForm.asObservable();

    private productoslist = new BehaviorSubject<any>(null);
    public productoslist$ = this.productoslist.asObservable();

    private accion = new BehaviorSubject<any>(null);
    public accion$ = this.accion.asObservable();

    private trasladoPor = new BehaviorSubject<any>(null);
    public trasladoPor$ = this.trasladoPor.asObservable();

    private tipoTransporte = new BehaviorSubject<any>(null);
    public tipoTransporte$ = this.tipoTransporte.asObservable();

    private countUbicaciones = new BehaviorSubject<any>(null);
    public countUbicaciones$ = this.countUbicaciones.asObservable();

    private tUbicacion = new BehaviorSubject<any>(null);
    public tUbicacion$ = this.tUbicacion.asObservable();

    //Formulario Transporte aereo
    private ferroForm = new BehaviorSubject<any>(null);
    public ferroForm$ = this.ferroForm.asObservable();

    //Formulario Transporte Ferro Paso
    private ferroPasoForm = new BehaviorSubject<any>(null);
    public ferroPasoForm$ = this.ferroPasoForm.asObservable();

    //Formulario Transporte Ferro Carro
    private ferroCarroForm = new BehaviorSubject<any>(null);
    public ferroCarroForm$ = this.ferroCarroForm.asObservable();

    //Formulario Transporte Ferro Carro Contenedor
    private ferroCarroContenedorForm = new BehaviorSubject<any>(null);
    public ferroCarroContenedorForm$ = this.ferroCarroContenedorForm.asObservable();

    //Formulario Transporte Maritimo
    private maritimoForm = new BehaviorSubject<any>(null);
    public maritimoForm$ = this.maritimoForm.asObservable();

    //Formulario Transporte Contenedor Maritimo
    private maritimoContenedorForm = new BehaviorSubject<any>(null);
    public maritimoContenedorForm$ = this.maritimoContenedorForm.asObservable();

    //Formulario Partes Transporte Contenedor 
    private parteTrasporteForm = new BehaviorSubject<any>(null);
    public parteTrasporteForm$ = this.parteTrasporteForm.asObservable();

    enviarValoresFormulariofacturaForm(valores: any) {
        this.formularioSubject.next(valores);
    }

    enviarValoresFormulariofacturaAdicionalesForm(valores: any) {
        this.AdicionalesformularioSubject.next(valores);
    }

    recibirValoresFormulariofacturaAdicionalesForm(valores: any) {
        this.llenarForm.next(valores);
    }

    productos(valores: any) {
        this.productoslist.next(valores);
    }

    //acciones de formulario
    //[0] Guardar
    //[1] Borrador
    //[2] Vista Previa
    //[3] Cancelar
    //[4] Actualizar
    acciones(accion: any) {
        this.accion.next(accion);
    }
    setIdFactura(idFactura) {
        this.idFactura.next(idFactura);
    }
    setFormAereos(formValues) {
        this.aereosForm.next(formValues);
    }
    setFormPedimentos(formValues) {
        this.pedimentos.next(formValues);
    }

    cambiarTraslado(id) {
        this.trasladoPor.next(id);
    }

    cambiarTransporte(id) {
        this.tipoTransporte.next(id);
    }

    contarUbicaciones(flag) {
        this.countUbicaciones.next(flag);
    }

    setFormFerroviarios(formValues) {
        this.ferroForm.next(formValues);
    }

    setFormFerroviariosPaso(formValues) {
        this.ferroPasoForm.next(formValues);
    }

    setFormFerroviariosCarro(formValues) {
        this.ferroCarroForm.next(formValues);
    }

    setFormFerroviariosCarroContenedor(formValues) {
        this.ferroCarroContenedorForm.next(formValues);
    }

    setFormMaritimo(formValues) {
        this.maritimoForm.next(formValues);
    }

    setFormMaritimoContenedor(formValues) {
        this.maritimoContenedorForm.next(formValues);
    }

    setFormParteTransporte(formValues) {
        this.parteTrasporteForm.next(formValues);
    }
}